import React, { useState, ReactNode } from "react";
import {
  Classes,
  Dialog,
  Button,
  FormGroup,
  InputGroup,
  Intent,
  TagInput,
} from "@blueprintjs/core";
import { TNewDropdownQuestion } from ".";
import { nanoid } from "nanoid";

export const DialogAddDropdownQuestion = ({
  isDialogOpen,
  toggleDialog,
  addPersonalQuestion,
}: {
  isDialogOpen: boolean;
  toggleDialog: () => void;
  addPersonalQuestion: (question: TNewDropdownQuestion) => void;
}) => {
  const [question, setQuestion] = useState<string>("");
  const [options, setOptions] = useState<string[]>([]);

  const onChangeQuestion = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuestion(e.target.value);
  };

  const onChangeOptions = (values: ReactNode[]) => {
    const stringValues = values
      .filter((value): value is string => typeof value === "string")
      .map((value) => String(value));

    setOptions(stringValues);
  };

  const handleSaveDropdownQuestion = () => {
    addPersonalQuestion({
      id: nanoid(),
      question,
      options,
    });
    setQuestion("");
    setOptions([]);
    toggleDialog();
  };

  return (
    // @ts-ignore
    <Dialog
      icon="add"
      title="Add personal dropdown question"
      autoFocus={true}
      canEscapeKeyClose={true}
      canOutsideClickClose={true}
      usePortal={true}
      enforceFocus={true}
      isOpen={isDialogOpen}
      onClose={toggleDialog}
    >
      <div className={Classes.DIALOG_BODY}>
        {/* @ts-ignore */}
        <FormGroup label="Question">
          <InputGroup
            id="feedback-question"
            name="question"
            onChange={onChangeQuestion}
          />
        </FormGroup>
        {/* @ts-ignore */}
        <FormGroup label="Options - Press enter when you are done typing an option">
          <TagInput values={options} onChange={onChangeOptions} />
        </FormGroup>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={toggleDialog} text="Cancel" />
          <Button
            onClick={handleSaveDropdownQuestion}
            text="Add"
            disabled={
              question == null || question.length === 0 || options.length === 0
            }
            intent={Intent.SUCCESS}
            rightIcon="add"
          />
        </div>
      </div>
    </Dialog>
  );
};
